import { array, boolean, mixed, number, object, string } from 'yup';
const AdditionalInformationValidation = object({
  citizenshipResidencyType: mixed().required('Please select Citizenship').oneOf(['USCitizen', 'PermanentResidentAlien', 'NonPermanentResidentAlien'], 'Please select Citizenship'),
  fullName: string().optional(),
  ssn: string().required('Please provide valid Social Security Number').min(9, 'Please provide valid Social Security Number').max(9, 'Please provide valid Social Security Number'),
  borrowerBirthDate: string().required('Please provide a valid date'),
  dependentCount: number().optional(),
  dependents: array().nullable().when(['dependentCount'], {
    is: count => count > 0,
    then: () => array().of(object({
      dependentAgeYearsCount: number().typeError('Please provide the age of the dependent').required('Please provide the age of the dependent')
    }))
  }),
  residences: object({
    present: object({
      sameAsPropertyAddress: boolean().nullable().default(false).required('Please select address type'),
      street: string().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please provide a valid address')
      }),
      unit: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.notRequired().transform((v, o) => o === '' ? null : v).matches(/^.[a-zA-Z0-9]+$/, 'Please provide valid unit number')
      }),
      cityName: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please provide valid city')
      }),
      stateCode: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please select state')
      }),
      postalCode: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please provide valid zip code').min(5, 'Please provide valid zip code').max(5, 'Please provide valid zip code').matches(/^[0-9]+$/, 'Please provide valid zip code')
      }),
      housingExpenseType: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please select a value')
      }),
      housingExpensePaymentAmount: string().nullable().when(['sameAsPropertyAddress', 'housingExpenseType'], {
        is: (address, type) => !address && type && type === 'Rent',
        then: schema => schema.required('Please provide rent amount').test('checkZero', 'Please provide rent amount', value => {
          return value ? Number(value) > 0 : false;
        })
      }),
      borrowerResidencyDurationYearsCount: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please provide years at this address').test({
          name: 'preYears',
          message: 'Please provide years at this address',
          test: function (value) {
            let valNum = Number(value);
            return valNum > 0 || Number(this.parent.borrowerResidencyDurationMonthsCount) > 0;
          }
        }).matches(/^[0-9]+$/, 'Please provide valid years at this address')
      }),
      borrowerResidencyDurationMonthsCount: string().nullable().when('sameAsPropertyAddress', {
        is: sameAsPropertyAddress => !sameAsPropertyAddress,
        then: schema => schema.required('Please provide months at this address').test({
          name: 'preMonths',
          message: 'Please provide months at this address',
          test: function (value) {
            let valNum = Number(value);
            return valNum > 0 || Number(this.parent.borrowerResidencyDurationYearsCount) >= 2;
          }
        }).matches(/^[0-9]+$/, 'Please provide valid months at this address')
      })
    }),
    previous: array().of(object({
      type: string().nullable().default('Prior'),
      street: string().required('Please provide a valid address'),
      unit: string().nullable().transform((v, o) => o === '' ? null : v).matches(/^.[a-zA-Z0-9]+$/, 'Please provide valid unit number'),
      cityName: string().required('Please provide valid city'),
      stateCode: string().required('Please select state'),
      postalCode: string().required('Please provide valid zip code').min(5, 'Please provide valid zip code').max(5, 'Please provide valid zip code').matches(/^[0-9]+$/, 'Please provide valid zip code'),
      borrowerResidencyDurationYearsCount: string().required('Please provide years at this address').test({
        name: 'prevYears',
        message: 'Please provide years at this address',
        test: function (value) {
          let valNum = Number(value);
          return valNum > 0 || Number(this.parent.borrowerResidencyDurationMonthsCount) > 0;
        }
      }).matches(/^[0-9]+$/, 'Please provide valid years at this address'),
      borrowerResidencyDurationMonthsCount: string().required('Please provide months at this address').test({
        name: 'prevMonths',
        message: 'Please provide months at this address',
        test: function (value) {
          let valNum = Number(value);
          return valNum > 0 || Number(this.parent.borrowerResidencyDurationYearsCount) > 0;
        }
      }).matches(/^[0-9]+$/, 'Please provide valid months at this address')
    })),
    mailing: object({
      sameAsPropertyAddress: boolean().nullable().default(false).required('Please select address type'),
      street: string().optional().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please provide a valid address')
      }),
      unit: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.notRequired().transform((v, o) => o === '' ? null : v).matches(/^.[a-zA-Z0-9]+$/, 'Please provide valid unit number')
      }),
      cityName: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please provide valid city')
      }),
      stateCode: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please select state')
      }),
      postalCode: string().nullable().when('sameAsPropertyAddress', {
        is: value => !value,
        then: schema => schema.required('Please provide valid zip code').min(5, 'Please provide valid zip code').max(5, 'Please provide valid zip code').matches(/^[0-9]+$/, 'Please provide valid zip code')
      }),
      type: string().nullable().default('Mailing')
    })
  })
});
export default AdditionalInformationValidation;
//# sourceMappingURL=index.js.map